export function calculateNextReview(interval, quality) {
  // 简化 SM-2 算法
  // interval: 当前间隔天数 (0 表示首次复习)
  // quality: 1-5, 5=完全掌握, 3=勉强记得, 1=完全忘记

  let nextInterval

  if (quality < 3) {
    // 没掌握，第二天重来
    nextInterval = 1
  } else {
    if (interval === 0) {
      nextInterval = 1
    } else if (interval === 1) {
      nextInterval = 3
    } else if (interval === 3) {
      nextInterval = 7
    } else if (interval === 7) {
      nextInterval = 15
    } else if (interval === 15) {
      nextInterval = 30
    } else {
      nextInterval = Math.round(interval * 2.5)
    }
  }

  return nextInterval
}

export function getTodayDate() {
  const now = new Date()
  const offset = now.getTimezoneOffset() * 60000
  return new Date(now.getTime() - offset).toISOString().split('T')[0]
}

export function formatTime(seconds) {
  const h = Math.floor(seconds / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  const s = seconds % 60
  if (h > 0) return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
  return `${m}:${String(s).padStart(2, '0')}`
}
